import React from 'react'

const FeedbackCallMessageBox = ({ children }) => {
  return (
    <div className='FeedbackCallMessageBox'>
      <p translate='no'>{children}</p>
    </div>
  )
}

export default FeedbackCallMessageBox
